import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import Dropzone from "react-dropzone";
import Swal from "sweetalert2/dist/sweetalert2.js";
import DocumentViewer from '../../../GeneralComponents/DocumentViewer';

// El backend rechaza lo que pase de 10 MB (Settings::ProcesoDocumentsController).
const MAX_FILE_SIZE = 10 * 1024 * 1024;

// Solo lo que el visor sabe mostrar; el backend valida lo mismo (extension y contenido).
const ACCEPTED_FILES = "application/pdf,image/png,image/jpeg,image/gif,image/webp,.pdf,.png,.jpg,.jpeg,.gif,.webp";
const ACCEPTED_EXTENSION = /\.(pdf|png|jpe?g|gif|webp)$/i;

const FILE_ICONS = [
    [/\.pdf$/i, "fas fa-file-pdf"],
    [/\.(docx?|odt)$/i, "fas fa-file-word"],
    [/\.(xlsx?|csv|ods)$/i, "fas fa-file-excel"],
    [/\.(pptx?|odp)$/i, "fas fa-file-powerpoint"],
    [/\.(png|jpe?g|gif|webp|svg)$/i, "fas fa-file-image"],
    [/\.(zip|rar|7z)$/i, "fas fa-file-archive"],
];

const fileIcon = (name) => {
    const clean = (name || "").split("?")[0];
    const match = FILE_ICONS.find(([regex]) => regex.test(clean));
    return match ? match[1] : "fas fa-file-alt";
};

const formatSize = (bytes) => {
    if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (isNaN(date.getTime())) return "";
    const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
};

const emptyForm = { fileName: "", file: null };

class ModalDocuments extends Component {
    constructor(props) {
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
            isSaving: false,
            isError: false,
            errorMessage: "",

            form: emptyForm,
            // Documento en edicion (null = el formulario sube uno nuevo)
            editing: null,
            // Documento abierto en el visor (null = cerrado)
            viewing: null,
        }
    }

    componentDidMount() {
        this.loadData();
    }

    url = () => `/settings/procesos/${this.props.proceso.id}/documents`

    loadData = () => {
        fetch(this.url(), {
            method: 'GET',
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
            .then(response => (response.ok ? response.json() : { data: [] }))
            .catch(() => ({ data: [] }))
            .then(data => {
                this.setState({ data: data.data || [], isLoaded: false });
            });
    }

    HandleChange = (e) => {
        this.setState({
            form: { ...this.state.form, [e.target.name]: e.target.value },
            errorMessage: "",
        });
    }

    handleFile = (files, rejected) => {
        const file = files[0];

        if (!file || !ACCEPTED_EXTENSION.test(file.name)) {
            if (file || (rejected && rejected.length)) {
                this.setState({
                    form: { ...this.state.form, file: null },
                    errorMessage: "Solo se pueden subir PDF o imágenes (JPG, PNG, GIF, WEBP). Un Word o Excel hay que exportarlo a PDF.",
                });
            }
            return;
        }

        if (file.size > MAX_FILE_SIZE) {
            this.setState({
                form: { ...this.state.form, file: null },
                errorMessage: "El archivo supera el máximo permitido (10 MB). Intenta con otro.",
            });
            return;
        }

        this.setState({
            form: {
                ...this.state.form,
                file: file,
                // Si aun no le pusieron nombre, se propone el del archivo sin extension.
                fileName: this.state.form.fileName != "" ? this.state.form.fileName : file.name.replace(/\.[^.]+$/, ""),
            },
            errorMessage: "",
        });
    }

    edit = (doc) => {
        this.setState({
            editing: doc,
            form: { fileName: doc.fileName || "", file: null },
            isError: false,
            errorMessage: "",
        });
    }

    cancelEdit = () => {
        this.setState({ editing: null, form: emptyForm, isError: false, errorMessage: "" });
    }

    HandleClick = () => {
        const { form, editing } = this.state;

        // Al editar, el archivo es opcional: sin archivo solo cambia el nombre.
        if (form.fileName.trim() == "" || (!editing && !form.file)) {
            this.setState({ isError: true });
            return;
        }

        this.setState({ isSaving: true, isError: false, errorMessage: "" });

        const formData = new FormData();
        formData.append("fileName", form.fileName.trim());
        if (form.file) formData.append("file", form.file);

        // Sin Content-Type: el navegador pone el multipart con su boundary.
        fetch(editing ? `${this.url()}/${editing.id}` : this.url(), {
            method: editing ? 'PATCH' : 'POST',
            body: formData,
            headers: { "X-CSRF-Token": this.token }
        })
            .then(res => res.json())
            .catch(() => ({ type: "error", success: "No se pudo guardar el documento. Intenta de nuevo." }))
            .then(data => {
                if (data.type == "success") {
                    this.setState({
                        data: editing
                            ? this.state.data.map(item => (item.id == editing.id ? data.register : item))
                            : [data.register, ...this.state.data],
                        isSaving: false,
                        editing: null,
                        form: emptyForm,
                    });
                    this.props.onChange();
                } else {
                    this.setState({ isSaving: false, errorMessage: data.success });
                }
            });
    }

    delete = (doc) => {
        Swal.fire({
            title: "¿Quitar este documento?",
            text: `"${doc.fileName}" dejará de aparecer en el proceso.`,
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`${this.url()}/${doc.id}`, {
                    method: "DELETE",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => response.json())
                    .catch(() => ({ type: "error", success: "No se pudo eliminar el documento." }))
                    .then(response => {
                        if (response.type == "success") {
                            this.setState({ data: this.state.data.filter(item => item.id != doc.id) });
                            if (this.state.editing && this.state.editing.id == doc.id) this.cancelEdit();
                            this.props.onChange();
                        } else {
                            this.setState({ errorMessage: response.success });
                        }
                    });
            }
        });
    }

    view = (doc) => {
        if (doc.kind) this.setState({ viewing: doc });
    }

    closeViewer = () => {
        this.setState({ viewing: null });
    }

    renderForm() {
        const { form, isError, isSaving, errorMessage, editing } = this.state;

        return (
            <div className="rk-doc-form">
                {editing && (
                    <div className="rk-doc-form__head">
                        <span><i className="fas fa-pencil-alt"></i> Editando «{editing.fileName}»</span>
                        <button type="button" className="rk-link-btn" onClick={this.cancelEdit}>Cancelar edición</button>
                    </div>
                )}

                <div className="row">
                    <div className="col-md-5">
                        <div className="rk-field">
                            <label className="rk-label">Nombre</label>
                            <input
                                type="text"
                                name="fileName"
                                value={form.fileName}
                                onChange={this.HandleChange}
                                className={`rk-input ${isError && form.fileName.trim() == "" ? "rk-input--error" : ""}`}
                                placeholder="Ej. Caracterización del proceso"
                            />
                        </div>
                    </div>

                    <div className="col-md-5">
                        <div className="rk-field">
                            <label className="rk-label">{editing ? "Reemplazar archivo (opcional)" : "Documento"}</label>
                            <Dropzone onDrop={this.handleFile} multiple={false} accept={ACCEPTED_FILES}>
                                {({ getRootProps, getInputProps, isDragActive }) => (
                                    <div
                                        {...getRootProps({
                                            className: `rk-dropzone ${isDragActive ? "is-active" : ""} ${form.file ? "is-filled" : ""} ${isError && !editing && !form.file ? "rk-input--error" : ""}`,
                                        })}
                                    >
                                        <input {...getInputProps()} />
                                        <i className={form.file ? fileIcon(form.file.name) : "fas fa-cloud-upload-alt"}></i>
                                        <span className="rk-dropzone__text">
                                            {form.file ? form.file.name : "Arrastra el archivo o haz clic"}
                                        </span>
                                        {form.file && <span className="rk-dropzone__size">{formatSize(form.file.size)}</span>}
                                    </div>
                                )}
                            </Dropzone>
                            <small className="rk-doc-form__hint">PDF o imagen (JPG, PNG, GIF, WEBP), máximo 10 MB</small>
                        </div>
                    </div>

                    <div className="col-md-2 rk-doc-form__submit">
                        <div className="rk-field" style={{ width: "100%" }}>
                            <button
                                type="button"
                                className="rk-btn rk-btn--primary"
                                onClick={this.HandleClick}
                                disabled={isSaving}
                            >
                                {isSaving ? <><i className="fas fa-spinner fa-spin"></i> {editing ? "Guardando…" : "Subiendo…"}</>
                                    : editing ? <><i className="fas fa-check"></i> Guardar</>
                                        : <><i className="fas fa-upload"></i> Subir</>}
                            </button>
                        </div>
                    </div>

                    {(isError || errorMessage != "") && (
                        <div className="col-md-12">
                            <div className="rk-alert" style={{ marginBottom: 14 }}>
                                <i className="fas fa-exclamation-circle"></i>
                                {errorMessage != "" ? errorMessage : "Debes poner un nombre y elegir un documento"}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { errorMessage, data, viewing, editing } = this.state;
        const canManage = this.props.canManage;

        return (
            <Modal
                isOpen={this.props.modal}
                toggle={this.props.toggle}
                className="modal-dialog-centered modal-lg rk-modal"
                backdrop={this.props.backdrop}
            >
                <div className="rk-modal__header">
                    <span className="rk-modal__header-icon"><i className="fas fa-folder-open"></i></span>
                    <h5>Documentos — {this.props.proceso.name}</h5>
                    <button type="button" className="rk-modal__close" onClick={() => this.props.toggle()}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <div className="rk-modal__body">
                    {canManage && this.renderForm()}

                    {/* Sin formulario (no admin), el error de una accion igual se muestra */}
                    {!canManage && errorMessage != "" && (
                        <div className="rk-alert" style={{ marginBottom: 14 }}>
                            <i className="fas fa-exclamation-circle"></i>
                            {errorMessage}
                        </div>
                    )}

                    {this.state.isLoaded ? (
                        <div className="rk-empty">
                            <i className="fas fa-spinner fa-spin"></i>
                            <p>Cargando documentos…</p>
                        </div>
                    ) : data.length >= 1 ? (
                        <div className="rk-doc-list">
                            {data.map(doc => {
                                const author = doc.user_register ? `${doc.user_register.first_name || ""} ${doc.user_register.first_last_name || ""}`.trim() : "";
                                const meta = [author, formatDate(doc.created_at)].filter(item => item != "").join(" · ");

                                return (
                                    <div className={`rk-doc ${editing && editing.id == doc.id ? "is-editing" : ""}`} key={doc.id}>
                                        <span className="rk-doc__icon"><i className={fileIcon(`.${doc.extension || ""}`)}></i></span>

                                        <div className="rk-doc__body">
                                            <div
                                                className={`rk-doc__name ${doc.kind ? "rk-doc__name--link" : ""}`}
                                                title={doc.fileName}
                                                onClick={() => this.view(doc)}
                                            >
                                                {doc.fileName}
                                            </div>
                                            {meta != "" && <div className="rk-doc__meta">{meta}</div>}
                                        </div>

                                        <div className="rk-doc__actions">
                                            {doc.kind ? (
                                                <button type="button" className="rk-icon-btn" onClick={() => this.view(doc)} title="Ver documento">
                                                    <i className="fas fa-eye"></i>
                                                </button>
                                            ) : (
                                                <span className="rk-doc__tag" title="Solo se pueden ver PDF e imágenes. Reemplázalo por su versión en PDF.">
                                                    Sin vista previa
                                                </span>
                                            )}
                                            {canManage && (
                                                <button type="button" className="rk-icon-btn" onClick={() => this.edit(doc)} title="Editar">
                                                    <i className="fas fa-pencil-alt"></i>
                                                </button>
                                            )}
                                            {canManage && (
                                                <button type="button" className="rk-icon-btn rk-icon-btn--cancel" onClick={() => this.delete(doc)} title="Eliminar">
                                                    <i className="fas fa-trash-alt"></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="rk-empty">
                            <i className="fas fa-folder-open"></i>
                            <p>Este proceso todavía no tiene documentos</p>
                        </div>
                    )}
                </div>

                <div className="rk-modal__footer">
                    <button type="button" className="rk-btn rk-btn--ghost" onClick={() => this.props.toggle()}>Cerrar</button>
                </div>

                {viewing && (
                    <DocumentViewer
                        document={viewing}
                        url={`${this.url()}/${viewing.id}`}
                        toggle={this.closeViewer}
                    />
                )}
            </Modal>
        );
    }
}

export default ModalDocuments;
